// import React, { useState } from 'react';
// import { styles } from '../styles/styles';

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     phone: '',
//     city: '',
//     service: '',
//     message: ''
//   });

//   const handleInputChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value
//     });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     const subject = `Lawn Care Quote Request - ${formData.city} - ${formData.service}`;
//     const body = `Name: ${formData.name}%0D%0APhone: ${formData.phone}%0D%0AEmail: ${formData.email}%0D%0ACity: ${formData.city}%0D%0AService: ${formData.service}%0D%0AMessage: ${formData.message}`;
//     window.location.href = `mailto:metro.mowing.fence@gmail.com?subject=${subject}&body=${body}`;
//   };

//   return (
//     <section id="contact" style={styles.contactSection}>
//       <div style={styles.contactContainer}>
//         <h2 style={styles.sectionTitle}>Get Your Free Lawn Care Quote Today</h2>
//         <p style={styles.sectionDescription}>
//           Ready to transform your Apple Valley, Rosemount, Eagan, Burnsville or Lakeville lawn? Contact us for a free, no-obligation quote.
//         </p>

//         <div style={styles.contactGrid} className="contact-grid">
//           {/* Contact Info */}
//           <div style={styles.contactInfo}>
//             <h3 style={styles.contactInfoTitle}>Contact Information</h3>
//             <div style={styles.contactItem}>
//               <div>
//                 <p style={styles.contactLabel}>Phone</p>
//                 <a href="tel:6123143917" style={styles.contactValue}>
//                   (612) 314-3917
//                 </a>
//               </div>
//             </div>
//             <div style={styles.contactItem}>
//               <div>
//                 <p style={styles.contactLabel}>Email</p>
//                 <a href="mailto:metro.mowing.fence@gmail.com" style={styles.contactValue}>
//                   metromowingMN@gmail.com
//                 </a>
//               </div>
//             </div>
//             <div style={styles.contactItem}>
//               <div>
//                 <p style={styles.contactLabel}>Service Areas</p>
//                 <p style={styles.contactValue}>Apple Valley, Rosemount, Eagan, Burnsville, Lakeville & South Metro</p>
//               </div>
//             </div>
//           </div>

//           {/* Contact Form */}
//           <div style={styles.form}>
//             <div style={styles.formGroup}>
//               <label style={styles.label}>Name *</label>
//               <input
//                 type="text"
//                 name="name"
//                 style={styles.input}
//                 value={formData.name}
//                 onChange={handleInputChange}
//                 onFocus={(e) => e.target.style.borderColor = '#494eb6'}
//                 onBlur={(e) => e.target.style.borderColor = '#ccc'}
//                 required
//               />
//             </div>
//             <div style={styles.formGroup}>
//               <label style={styles.label}>Phone *</label>
//               <input
//                 type="tel"
//                 name="phone"
//                 style={styles.input}
//                 value={formData.phone}
//                 onChange={handleInputChange}
//                 onFocus={(e) => e.target.style.borderColor = '#494eb6'}
//                 onBlur={(e) => e.target.style.borderColor = '#ccc'}
//                 required
//               />
//             </div>
//             <div style={styles.formGroup}>
//               <label style={styles.label}>Email</label>
//               <input
//                 type="email"
//                 name="email"
//                 style={styles.input}
//                 value={formData.email}
//                 onChange={handleInputChange}
//                 onFocus={(e) => e.target.style.borderColor = '#494eb6'}
//                 onBlur={(e) => e.target.style.borderColor = '#ccc'}
//               />
//             </div>
//             <div style={styles.formGroup}>
//               <label style={styles.label}>City *</label>
//               <select
//                 name="city"
//                 style={styles.select}
//                 value={formData.city}
//                 onChange={handleInputChange}
//                 onFocus={(e) => e.target.style.borderColor = '#494eb6'}
//                 onBlur={(e) => e.target.style.borderColor = '#ccc'}
//                 required
//               >
//                 <option value="">Select your city</option>
//                 <option value="Apple Valley">Apple Valley</option>
//                 <option value="Rosemount">Rosemount</option>
//                 <option value="Lakeville">Lakeville</option>
//                 <option value="Eagan">Eagan</option>
//                 <option value="Burnsville">Burnsville</option>
//                 <option value="Other South Metro">Other</option>
//               </select>
//             </div>
//             <div style={styles.formGroup}>
//               <label style={styles.label}>Service Needed</label>
//               <select
//                 name="service"
//                 style={styles.select}
//                 value={formData.service}
//                 onChange={handleInputChange}
//                 onFocus={(e) => e.target.style.borderColor = '#494eb6'}
//                 onBlur={(e) => e.target.style.borderColor = '#ccc'}
//               >
//                 <option value="">Select a service</option>
//                 <option value="Regular Mowing">Mowing</option>
//                 <option value="Weed Control">Weed Control</option>
//                 <option value="Mulch Installation">Mulch Installation</option>
//                 <option value="Seasonal Cleanup">Seasonal Cleanup</option>
//                 <option value="Multiple Services">Multiple Services</option>
//               </select>
//             </div>
//             <div style={styles.formGroup}>
//               <label style={styles.label}>Message</label>
//               <textarea
//                 name="message"
//                 style={styles.textarea}
//                 placeholder="Tell us about your Apple Valley, Rosemount, Eagan, Burnsville or Lakeville property and lawn care needs..."
//                 value={formData.message}
//                 onChange={handleInputChange}
//                 onFocus={(e) => e.target.style.borderColor = '#494eb6'}
//                 onBlur={(e) => e.target.style.borderColor = '#ccc'}
//               />
//             </div>
//             <button
//               onClick={handleSubmit}
//               style={styles.submitButton}
//               onMouseEnter={(e) => e.target.style.opacity = '0.9'}
//               onMouseLeave={(e) => e.target.style.opacity = '1'}
//             >
//               Send Quote Request
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Contact;





// #############################################################################################################################







import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import { styles } from '../styles/styles';
import phoneIcon from '../assets/contact-icons/phone.svg';
import mailIcon from '../assets/contact-icons/mail.svg';
import mapPinIcon from '../assets/contact-icons/map-pin.svg';

const contactIconCircle = {
  width: '48px',
  height: '48px',
  flexShrink: 0,
  borderRadius: '50%',
  backgroundColor: 'white',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    city: '',
    service: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(''); // 'success', 'error', or ''

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('');

    // Basic validation
    if (!formData.name || !formData.phone || !formData.city) {
      setSubmitStatus('error');
      setIsSubmitting(false);
      return;
    }

    try {
      // EmailJS configuration - you'll need to replace these with your actual values
      const templateParams = {
        from_name: formData.name,
        from_email: formData.email || 'No email provided',
        phone: formData.phone,
        city: formData.city,
        service: formData.service || 'Not specified',
        message: formData.message || 'No additional message',
        to_email: 'metro.mowing.fence@gmail.com'
      };

      // Send email using EmailJS
      await emailjs.send(
        'service_4s4gbn8',      // Replace with your EmailJS Service ID
        'template_yzu6zdb',     // Replace with your EmailJS Template ID
        templateParams,
        'iXcue5iM9LcyrTupw'       // Replace with your EmailJS Public Key
      );

      // Success
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        city: '',
        service: '',
        message: ''
      });

    } catch (error) {
      console.error('EmailJS Error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
      // Auto-hide status message after 5 seconds
      setTimeout(() => setSubmitStatus(''), 5000);
    }
  };

  return (
    <section id="contact" style={styles.contactSection}>
      <div style={styles.contactContainer}>
        <h2 style={styles.sectionTitle}>Get Your Free Lawn Care Quote Today</h2>
        <p style={styles.sectionDescription}>
          Ready to transform your Apple Valley, Rosemount, Eagan, Burnsville or Lakeville lawn? Contact us for a free, no-obligation quote.
        </p>

        <div style={styles.contactGrid} className="contact-grid">
          {/* Contact Info */}
          <div style={styles.contactInfo}>
            <h3 style={styles.contactInfoTitle}>Contact Information</h3>
            <div style={styles.contactItem}>
              <div style={contactIconCircle}>
                <img src={phoneIcon} alt="" style={{ width: '26px', height: '26px' }} />
              </div>
              <div>
                <p style={styles.contactLabel}>Phone</p>
                <a href="tel:6513137009" style={styles.contactValue}>
                  (651) 313-7009
                </a>
              </div>
            </div>
            <div style={styles.contactItem}>
              <div style={contactIconCircle}>
                <img src={mailIcon} alt="" style={{ width: '26px', height: '26px' }} />
              </div>
              <div>
                <p style={styles.contactLabel}>Email</p>
                <a
                  href="mailto:metromowingmn@gmail.com"
                  style={styles.contactValue}
                  onClick={(e) => {
                    e.preventDefault();
                    navigator.clipboard.writeText('MetroMowingMN@gmail.com');
                    // Optional: Show feedback to user
                    alert('Email copied to clipboard!');
                  }}
                >
                  MetroMowingMN@gmail.com
                </a>
              </div>
              {/* <div>
                <p style={styles.contactLabel}>Email</p>
                <a href="mailto:metromowingmn@gmail.com" style={styles.contactValue}>
                  MetroMowingMN@gmail.com
                </a>
              </div> */}
            </div>
            <div style={styles.contactItem}>
              <div style={contactIconCircle}>
                <img src={mapPinIcon} alt="" style={{ width: '26px', height: '26px' }} />
              </div>
              <div>
                <p style={styles.contactLabel}>Service Areas</p>
                <p style={styles.contactValue}>Apple Valley, Rosemount, Eagan, Burnsville Lakeville & South Metro</p>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div style={styles.form}>
            {/* Status Messages */}
            {/* {submitStatus === 'success' && (
              <div style={{
                backgroundColor: '#4CAF50',
                color: 'white',
                padding: '1rem',
                borderRadius: '8px',
                marginBottom: '1rem',
                textAlign: 'center'
              }}>
                Quote request sent successfully! We'll contact you soon.
              </div>
            )} */}

            {submitStatus === 'error' && (
              <div style={{
                backgroundColor: '#f44336',
                color: 'white',
                padding: '1rem',
                borderRadius: '8px',
                marginBottom: '1rem',
                textAlign: 'center'
              }}>
                Error sending request. Please try again or call us directly.
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div style={styles.formGroup}>
                <label style={styles.label}>Name *</label>
                <input
                  type="text"
                  name="name"
                  style={styles.input}
                  value={formData.name}
                  onChange={handleInputChange}
                  onFocus={(e) => e.target.style.borderColor = '#494eb6'}
                  onBlur={(e) => e.target.style.borderColor = '#ccc'}
                  required
                  disabled={isSubmitting}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Phone *</label>
                <input
                  type="tel"
                  name="phone"
                  style={styles.input}
                  value={formData.phone}
                  onChange={handleInputChange}
                  onFocus={(e) => e.target.style.borderColor = '#494eb6'}
                  onBlur={(e) => e.target.style.borderColor = '#ccc'}
                  required
                  disabled={isSubmitting}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Email</label>
                <input
                  type="email"
                  name="email"
                  style={styles.input}
                  value={formData.email}
                  onChange={handleInputChange}
                  onFocus={(e) => e.target.style.borderColor = '#494eb6'}
                  onBlur={(e) => e.target.style.borderColor = '#ccc'}
                  disabled={isSubmitting}
                />
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>City *</label>
                <select
                  name="city"
                  style={styles.select}
                  value={formData.city}
                  onChange={handleInputChange}
                  onFocus={(e) => e.target.style.borderColor = '#494eb6'}
                  onBlur={(e) => e.target.style.borderColor = '#ccc'}
                  required
                  disabled={isSubmitting}
                >
                  <option value="">Select your city</option>
                  <option value="Apple Valley">Apple Valley</option>
                  <option value="Rosemount">Rosemount</option>
                  <option value="Lakeville">Lakeville</option>
                  <option value="Eagan">Eagan</option>
                  <option value="Burnsville">Burnsville</option>
                  <option value="Other South Metro">Other</option>
                </select>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Service Needed</label>
                <select
                  name="service"
                  style={styles.select}
                  value={formData.service}
                  onChange={handleInputChange}
                  onFocus={(e) => e.target.style.borderColor = '#494eb6'}
                  onBlur={(e) => e.target.style.borderColor = '#ccc'}
                  disabled={isSubmitting}
                >
                  <option value="">Select a service</option>
                  <option value="Regular Mowing">Weekly Mowing</option>
                  <option value="Weed Control">Weed Control</option>
                  {/* <option value="Mulch Installation">Mulch Installation</option> */}
                  <option value="Seasonal Cleanup">Seasonal Cleanup</option>
                  <option value="Multiple Services">Multiple Services</option>
                  <option value="Other">Other</option>
                </select>
              </div>

              <div style={styles.formGroup}>
                <label style={styles.label}>Message</label>
                <textarea
                  name="message"
                  style={styles.textarea}
                  placeholder="Tell us about your Apple Valley, Rosemount, Eagan, Burnsville or Lakeville property and lawn care needs..."
                  value={formData.message}
                  onChange={handleInputChange}
                  onFocus={(e) => e.target.style.borderColor = '#494eb6'}
                  onBlur={(e) => e.target.style.borderColor = '#ccc'}
                  disabled={isSubmitting}
                />
              </div>

              <button
                type="submit"
                style={{
                  ...styles.submitButton,
                  opacity: isSubmitting ? 0.7 : 1,
                  cursor: isSubmitting ? 'not-allowed' : 'pointer'
                }}
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Sending...' : 'Send Quote Request'}

                {submitStatus === 'success' && (
                  <div style={{
                    backgroundColor: '#4CAF50',
                    color: 'white',
                    padding: '1rem',
                    borderRadius: '8px',
                    marginBottom: '1rem',
                    textAlign: 'center'
                  }}>
                    Quote request sent successfully! We'll contact you soon.
                  </div>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;